import { combineReducers } from 'redux';
import { events } from './events';

export const gallery = combineReducers({
  events,
})